import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import ContactSocial from './ContactSocial';
import { Box } from '@mui/material';
import styled from 'styled-components';
// import { useTheme } from '@mui/material/styles';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { ReactComponent as Tiktok } from './../../assets/icons/Tiktok.svg'
import { ReactComponent as SnapChat } from './../../assets/icons/SnapChat.svg'


const StyledBox = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 5px;
  transition: transform 0.3s ease, background-color 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    background-color: #F1C114;
  }

  svg {
    transition: transform 0.3s ease;
     color: #fff;
     fill:#fff;
     width:1.5rem;
     height:1.5rem;
  }

  &:hover svg {
    transform: rotate(-20deg) scale(1.2);
  }
`;
const Social = ({ data }) => {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2, flexWrap: { md: 'nowrap', xs: 'wrap' }, justifyContent: { md: 'center' ,xs:'flex-start' } }}>
                {data?.instagramUrl &&
                    <ContactSocial link={data?.instagramUrl} >
                        <StyledBox>
                            <InstagramIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.facebookUrl &&
                    <ContactSocial link={data?.facebookUrl} >
                        <StyledBox>
                            <FacebookIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.linkedinUrl &&
                    <ContactSocial link={data?.linkedinUrl} >
                        <StyledBox>
                            <LinkedInIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.snapchatUrl &&
                    <ContactSocial link={data?.snapchatUrl}>
                        <StyledBox>
                            <SnapChat />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.twitterUrl &&
                    <ContactSocial link={data?.twitterUrl}>
                        <StyledBox>
                            <XIcon />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.tiktokUrl &&
                    <ContactSocial link={data?.tiktokUrl}>
                        <StyledBox>
                            <Tiktok />
                        </StyledBox>
                    </ContactSocial>
                }
            </Box>
        </>
    )
}

export default Social